import {
  GET_INCIDENT_IMAGES_FAIL,
  GET_INCIDENT_IMAGES_REQUEST,
  GET_INCIDENT_IMAGES_SUCCESS,
} from "../actions/element-classification";

const initialState = {
  incidentImages: {
    loading: true,
    data: [],
  },
};

export default function elements(state = initialState, action) {
  switch (action.type) {
    case GET_INCIDENT_IMAGES_REQUEST:
      return {
        ...state,
        incidentImages: {
          ...state.incidentImages,
          loading: true
        },
      };
    case GET_INCIDENT_IMAGES_SUCCESS:
      return {
        ...state,
        incidentImages: {
          loading: false,
          data: action.payload
        },

      };
    case GET_INCIDENT_IMAGES_FAIL:
      return {
        ...state,
        incidentImages: {
          ...state.incidentImages,
          loading: false,
        },
      };

    default:
      return state;
  }
}
